import { withMotion } from '@hoc/withMotion';
import SvgArrow from '@img/icons/arrow-left.svg';
import SvgChevron from '@img/icons/chevron-up.svg';
import SvgCross from '@img/icons/cross-squared.svg';
import SvgTick from '@img/icons/tick-thin.svg';
import Button from '@stories/Components/Buttons/Button/Button';
import Checkbox from '@stories/Components/Inputs/Checkbox/Checkbox';
import Dropdown from '@stories/Components/Inputs/Dropdown/Dropdown';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import DropdownFilter from './DropdownFilter/DropdownFilter';
import S from './Filters.styles';
const Filters = (props) => {
    const [advancedFiltersActive, setAdvancedFiltersActive] = React.useState(false);
    const [mobileFilterActive, setMobileFilterActive] = React.useState(-1);
    React.useEffect(() => {
        const header = document.querySelector('header');
        if (!header) {
            return;
        }
        if (mobileFilterActive > -1) {
            header.style.zIndex = '1';
        }
        else {
            header.style.zIndex = '100';
        }
    }, [mobileFilterActive]);
    if (!props.sortOptions && !props.filterOptions) {
        return null;
    }
    const hasFilters = props.filterOptions && props.filterOptions.length > 0;
    const activeFilters = !hasFilters
        ? []
        : props.filterOptions?.filter((filter) => filter.value.length > 0);
    const dup = hasFilters ? props.filterOptions : [];
    const filterOptions = props.hasAdvancedFilters ? dup?.slice(0, 2) : dup;
    const advancedFilterOptions = props.hasAdvancedFilters ? dup?.slice(2) : [];
    return (React.createElement(S.Wrapper, { "data-variant": props.variant, "data-many-filters": props.filterOptions && props.filterOptions.length > 3 && !props.hasAdvancedFilters, "data-has-advanced": advancedFilterOptions && advancedFilterOptions.length > 0 },
        React.createElement(S.Container, null,
            hasFilters ? (React.createElement(React.Fragment, null,
                React.createElement(S.FiltersWrapper, null,
                    filterOptions?.map((filter) => (React.createElement(DropdownFilter, { key: `filter-${filter.name}`, ...filter }))),
                    activeFilters && activeFilters.length > 0 && (React.createElement(S.Unset, null,
                        props.selectedTitle && React.createElement(S.UnsetTitle, null, props.selectedTitle),
                        activeFilters.map((filter) => (React.createElement(React.Fragment, { key: `filter-${filter.name}-active` }, filter.options.map((option) => (React.createElement(React.Fragment, null, option.options.map((o) => {
                            if (!filter.value.includes(o.value)) {
                                return null;
                            }
                            return (React.createElement(S.UnsetButton, { key: `option-${filter.name}-${o.value}-remove`, onClick: () => filter.onChange(o.value) },
                                React.createElement("span", null, o.text),
                                " ",
                                React.createElement(SvgCross, null)));
                        }))))))),
                        props.clearAll && (React.createElement(S.UnsetButton, { "data-type": "clear-all", onClick: props.clearAll },
                            React.createElement("span", null, "Clear All"),
                            " ",
                            React.createElement(SvgCross, null)))))),
                React.createElement(Button, { buttonType: "blue-outline", icon: "chevron", iconPosition: "right", onClick: () => setMobileFilterActive(0) }, "Filters"))) : null,
            props.sortOptions && (React.createElement(Dropdown, { name: props.sortOptions.name, value: props.sortOptions.value, onChange: (event) => props.sortOptions?.onChange(event.target.value) },
                React.createElement("option", { hidden: true, value: "" }, props.sortOptions.label),
                props.sortOptions.options.map((option) => (React.createElement("option", { key: `option-${option.value}`, value: option.value }, option.text))))),
            hasFilters ? (React.createElement(React.Fragment, null,
                React.createElement(S.Background, { "data-active": mobileFilterActive > -1, onClick: () => setMobileFilterActive(-1) }),
                React.createElement(S.Tray, { "data-active": mobileFilterActive > -1 },
                    React.createElement(S.TrayTitle, null, "Filters"),
                    React.createElement(S.FilterList, null, props.filterOptions?.map((filter, i) => (React.createElement(S.FilterItem, { key: `filter-${filter.name}-button` },
                        React.createElement(S.FilterButton, { onClick: () => setMobileFilterActive(i + 1) },
                            filter.label,
                            filter.value.length > 0 && React.createElement("span", null, filter.value.length)))))),
                    renderCloseButton()),
                props.filterOptions?.map((filter, i) => (React.createElement(S.Tray, { key: `filter-${filter.name}-tray`, "data-active": mobileFilterActive == i + 1 },
                    React.createElement(S.FilterTop, null,
                        renderBackButton(filter.label),
                        filter.value.length > 0 ? renderClearAll(filter.onClear) : renderAllSelected()),
                    React.createElement(S.FilterList, null, filter.options.map((option) => (React.createElement(React.Fragment, { key: `option-${filter.name}-${option.label}-mobile` },
                        filter.options.length > 1 && (React.createElement(S.FilterItem, { "data-label": true }, option.label)),
                        option.options.map((o) => (React.createElement(S.FilterItem, { key: `option-${filter.name}-${o.value}-mobile` },
                            React.createElement(Checkbox, { id: `${filter.name}-${o.value}-mobile`, name: `${filter.name}-${o.value}-mobile`, value: o.value, onChange: (event) => filter.onChange(event.target.value), checked: filter.value.includes(o.value), labelText: o.text })))))))),
                    renderCloseButton()))))) : null),
        advancedFilterOptions && advancedFilterOptions.length > 0 && (React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
            React.createElement(S.AdvancedWrapper, { initial: advancedFiltersActive ? 'opened' : 'closed', animate: advancedFiltersActive ? 'opened' : 'closed', variants: {
                    closed: {
                        height: 0,
                        overflow: 'hidden',
                        transitionEnd: {
                            visibility: 'hidden',
                        },
                    },
                    opened: {
                        visibility: 'visible',
                        height: 'auto',
                        transitionEnd: {
                            overflow: 'visible',
                        },
                    },
                } },
                React.createElement(S.FiltersWrapper, null, advancedFilterOptions.map((filter) => (React.createElement(DropdownFilter, { key: `filter-${filter.name}`, ...filter }))))),
            React.createElement(S.AdvancedButton, { onClick: () => setAdvancedFiltersActive(!advancedFiltersActive), "data-open": advancedFiltersActive }, advancedFiltersActive ? (React.createElement(React.Fragment, null,
                React.createElement("span", null, "Close"),
                React.createElement("span", null,
                    React.createElement(SvgCross, null)))) : (React.createElement(React.Fragment, null,
                React.createElement("span", null, "Advanced Filters"),
                React.createElement("span", null,
                    React.createElement(SvgChevron, null)))))))));
    function renderCloseButton() {
        return (React.createElement(Button, { buttonType: "blue-solid", onClick: () => setMobileFilterActive(-1) }, props.viewButtonLabel));
    }
    function renderBackButton(title) {
        return (React.createElement(S.BackButton, { onClick: () => setMobileFilterActive(0) },
            React.createElement(SvgArrow, null),
            " ",
            React.createElement("span", null, title)));
    }
    function renderAllSelected() {
        return (React.createElement(S.ClearButton, { as: "div" },
            React.createElement("span", null, "All"),
            " ",
            React.createElement(SvgTick, null)));
    }
    function renderClearAll(onClick) {
        return React.createElement(S.ClearButton, { onClick: onClick }, "Clear All");
    }
};
export default withMotion(Filters);
